"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPortalsRoot = createPortalsRoot;
exports.makePortalsRootGetter = makePortalsRootGetter;

var _canUseDOM = _interopRequireDefault(require("../../../utils/canUseDOM"));

var _constants = require("../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function createPortalsRoot() {
  var existingPortalsRoot = document.getElementById(_constants.PORTALS_ROOT_ID);

  if (existingPortalsRoot) {
    // our portals root already exists
    return existingPortalsRoot;
  }

  var portalsRoot = document.createElement('div');
  portalsRoot.setAttribute('id', _constants.PORTALS_ROOT_ID);
  document.body.appendChild(portalsRoot);
  return portalsRoot;
}

function makePortalsRootGetter(portalsRoot) {
  return function (selector) {
    var element = null;
    /* istanbul ignore if */

    if (!_canUseDOM.default) {
      return null;
    }

    if (typeof selector === 'string' && selector) {
      element = document.querySelector(selector);

      if (!element) {
        // eslint-disable-next-line no-console
        console.warn("[getPortalsRootElement]: unable to resolve the selector \"".concat(selector, "\". Falling back to the value of the \"portalsRoot\" configuration value."));
      }
    }

    if (!element) {
      element = typeof portalsRoot === 'string' ? document.querySelector(portalsRoot) : portalsRoot;

      if (!element) {
        // eslint-disable-next-line no-console
        console.warn("[getPortalsRootElement]: unable to resolve \"portalsRoot\" to a DOM node. Falling back to \"document.body\". Please make sure you provide an existing DOM node, or a valid CSS selector that matches one.");
        element = document.body;
      }
    }

    return element;
  };
}